export class SaIpsTransactionModal {
  Id: string;
  PaymentId: string;
  InvoiceId: string;
  ProductId: string;
  ProductName: string;
  PromoId: string;
  PromoName: string;
  Sa_generatelicense_id: string;
  Quantity: number;
  AmountRecieved: number;
  DiscountAmount: number;
  TotalAmount: number;
  Status: boolean;
  PaymentType: number;
  ProductUserName: string;
  PaymentDescription: string;
  TransactionDate: string;
  ProductAmount: number;
}
